import React, { FC } from 'react';
import { SkeletonSquare } from '@fiverr-private/feedback';
import { Container } from '@fiverr-private/layout_components';

export const MediaSkeleton: FC = () => (
  <Container top={0} left={0} width="100%" height="100%" position="absolute">
    <SkeletonSquare width="100%" height="100%" />
  </Container>
);
